<template>
  <div role="status" :class="classes" data-test-id="skeleton">
    <slot></slot>
    <span class="tw-sr-only">Loading...</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { Size } from "./types";

export interface SkeletonProps {
  size?: Size;
}

const sizes = {
  sm: "tw-max-w-sm",
};

const props = withDefaults(defineProps<SkeletonProps>(), {
  size: "sm",
});

const classes = computed(() => {
  return [sizes[props.size], "tw-animate-pulse"];
});
</script>
